var OptGroup = function OptGroup() {
  return null;
};

OptGroup.isSelectOptGroup = true;
OptGroup.displayName = 'ASelectOptGroup';
export default OptGroup;